import { useBreakpoints } from '@utils/viewportUtils';
import React from 'react';
import MobileMenu from './components/MobileMenu';
import WebMenu from './components/WebMenu';
import Styles from './styles';
import getConfig from 'next/config';
import { useLocale } from 'src/locales';

const MainNavigation: React.FC = () => {
  const { tabletAndDown } = useBreakpoints();
  const locale = useLocale();

  return (
    <Styles.Nav>
      <Styles.Container centeredContent fullHeight variant="no-shadow">
        <Styles.LogoImage href={`${getConfig().publicRuntimeConfig.SGE_UNIFY_URL}/export/${locale}`}>
          <img src="/static/icons/sgeLogo.svg" width={tabletAndDown ? '120px' : 'auto'} />
        </Styles.LogoImage>
        <WebMenu />
        <MobileMenu />
      </Styles.Container>
    </Styles.Nav>
  );
};

export default MainNavigation;
